import { cx } from '@mage-ui/styled-system/css';
import {
  bubblePlaceholder,
  title as titleRecipe,
} from '@mage-ui/styled-system/recipes';
import { LogoSymbol } from '../../data-display/logos/LogoSymbol';

export const BubblePlaceholder = ({ title }) => {
  const initials = title
    .split(' ')
    .map((word) => word[0])
    .join('');
  return (
    <div className={bubblePlaceholder().root}>
      <span
        className={cx(
          titleRecipe({ size: '5', weight: 'bold' }),
          bubblePlaceholder().title,
        )}
      >
        {initials.toUpperCase().substring(0, 2)}
      </span>

      <LogoSymbol
        className={bubblePlaceholder().icon}
        title='Logo bubble EOI'
        symbol='bubble-svg'
        viewBox='0 0 99 99'
      />
    </div>
  );
};
